import { render, staticRenderFns } from "./VanTrucking.vue?vue&type=template&id=79d29dc1"
import script from "./VanTrucking.vue?vue&type=script&lang=js"
export * from "./VanTrucking.vue?vue&type=script&lang=js"
import style0 from "./VanTrucking.vue?vue&type=style&index=0&id=79d29dc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports